<script setup>
import { computed, onBeforeUnmount, ref, watch } from "vue";
import { provideActionBar } from "./context";

const props = defineProps({
  open: { type: Boolean, default: undefined },
  defaultOpen: { type: Boolean, default: false },
  closeOnEscape: { type: Boolean, default: true },
  positioning: { type: Object, default: () => ({}) },
});

const emit = defineEmits(["update:open"]);

const internalOpen = ref(props.defaultOpen);
const isControlled = computed(() => props.open !== undefined);
const isOpen = computed(() =>
  isControlled.value ? props.open : internalOpen.value
);

function open() {
  if (!isControlled.value) internalOpen.value = true;
  emit("update:open", true);
}

function close() {
  if (!isControlled.value) internalOpen.value = false;
  emit("update:open", false);
}

const positioning = computed(() => ({
  placement: "bottom",
  gutter: "16px",
  ...props.positioning,
}));

function onKeydown(event) {
  if (event.key !== "Escape" || event.defaultPrevented) return;
  event.preventDefault();
  close();
}

watch(
  () => isOpen.value && props.closeOnEscape,
  (active) => {
    if (active) window.addEventListener("keydown", onKeydown);
    else window.removeEventListener("keydown", onKeydown);
  },
  { immediate: true }
);

onBeforeUnmount(() => window.removeEventListener("keydown", onKeydown));

provideActionBar({ isOpen, open, close, positioning });
</script>

<template>
  <slot />
</template>
